<template>
  <div class="main-layout predicted-item-page">
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="城镇医疗保险"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <div class="form-container">
            <el-form
              :model="form"
              ref="ruleForm"
              label-width="280px"
              label-position="left"
            >
              <el-form-item label="是否在本校参加城乡居民基本医疗保险">
                <el-switch
                  v-model="isOrNot"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>
              <div class="tips-container">
                <div class="tips">
                  <div class="title">
                    <i class="el-icon-info"></i><span>在校参保温馨提示</span>
                  </div>
                  <p>
                    1.城乡居民基本医疗保险是由政府主导，保障城乡居民（包括学生）健康，抵制疾病风险为目的一项惠民政策，实行个人缴费和政府补助相结合的筹资机制。
                    按照国家医疗保险属地管理原则（在哪里参保，就在哪里享受医疗保险待遇），建议我校大学生入学后参加鄂州市城乡居民基本医疗保险。
                  </p>
                  <p>
                    2.符合政府代缴条件的困难特殊人群（城乡低保人员、特困人员、孤儿、残疾人、低收入家庭人员、农村建档立卡人员）不须在校参保缴费，须在户籍所在地参保缴费。
                  </p>
                </div>
              </div>
              <div class="tips-container" v-if="isOrNot == 0">
                <div class="template-download">
                  <a :href="link">点击下载承诺书模板</a>
                </div>
                <div class="img-upload">
                  <div class="evidence-upload upload-item">
                    <div class="title">
                      <span class="red">*</span>上传承诺书及家长身份证复印件
                    </div>
                    <el-upload
                      action="/account/sys/static/upload"
                      list-type="picture-card"
                      accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                      :file-list="fileList"
                      :headers="{ token }"
                      :on-success="handlePictureSuccess"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handlePictureRemove"
                      :on-error="handleError"
                    >
                      <i class="el-icon-plus" slot="default"></i>
                    </el-upload>
                  </div>
                </div>
              </div>
              <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog ::close-on-click-modal="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
      token: "",
      isOrNot: 1,
      studentId: "",
      forecastLinkId: "",
      isSubmit: false,
      link: "http://yx.ezu.cn/static/welcome/不在校参加医保承诺书.docx",
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      handleData: {},
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.token = localStorage.getItem("token");
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).number;
    this.forecastLinkId = this.$route.params.id;
    this.isOrNot =
      this.$route.params.isOrNot == "null"
        ? 1
        : Number(this.$route.params.isOrNot);
    this.status = this.$route.params.status;
    // 初始化handleData
    this.handleData = {
      studentId: this.studentId,
      forecastLinkId: this.forecastLinkId,
      isOrNot: this.isOrNot,
      pictureUrl: [],
    };
    // 获取详情
    this.handleGet();
  },
  mounted() {
    if (this.status == 0) {
      this.$confirm("请确认是否在本校参加城乡居民基本医疗保险", "请确认", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        showClose: false,
        type: "warning",
        center: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(() => {
          console.log("是");
          this.isOrNot = 1;
          this.handleConfirm();
        })
        .catch(() => {
          console.log("否");
          this.isOrNot = 0;
          this.$message.warning("请按要求提交相关资料！");
        });
    }
  },
  methods: {
    submit() {
      // 当选择不参加城镇医保时，校验是否上传了承诺书
      if (this.isOrNot == 0 && this.fileList.length == 0) {
        return this.$message.error("请上传承诺书及家长身份证复印件！");
      }
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleConfirm();
        })
        .catch(() => {});
    },
    // 确认提交
    handleConfirm() {
      this.handleData.isOrNot = this.isOrNot;
      if (this.isOrNot == 1) {
        this.handleData.pictureUrl = [];
      } else {
        let pictureUrl = this.fileList.map((item) => item.url);
        this.handleData.pictureUrl = pictureUrl;
      }
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleSave();
      }
    },
    // 获取城镇医保详情
    handleGet() {
      this.$http
        .get(
          `/welcome-live/student/forecast/${this.forecastLinkId}/${this.studentId}`
        )
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.handleData = res.data;
              if (res.data.pictureUrl.length) {
                res.data.pictureUrl.forEach((item) =>
                  this.fileList.push({ url: item })
                );
              }
            }
          }
        })
        .catch((err) => {});
    },
    // 新增数据
    handleSave() {
      this.isSubmit = true;
      let params = Object.assign({}, this.handleData);
      this.$http
        .post("/welcome-live/student/forecast/saveInsurance", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error(res.msg);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error("操作失败" + err);
          this.isSubmit = false;
        });
    },
    // 更新数据
    handleUpdate() {
      this.isSubmit = true;
      let params = Object.assign({}, this.handleData);
      this.$http
        .post("/welcome-live/student/forecast/updateInsurance", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error(res.msg);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error("操作失败" + err);
          this.isSubmit = false;
        });
    },
    handlePictureSuccess(res, file, fileList) {
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleFormRemove(file, fileList) {
      this.formFileList = fileList;
    },
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
  },
};
</script>
